import React from "react";

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../../ui/card";

export default function PublicFormCapabilityNotice({
  capabilities,
  formCount = 0,
}) {
  const formLimit = Number(capabilities?.max_public_forms ?? 0);
  const hasCore = Boolean(capabilities?.crm_core_enabled);
  const hasFyreFunnel = Boolean(capabilities?.fyrefunnel_enabled);
  const hasPublicForms = Boolean(capabilities?.public_forms_enabled);

  if (!hasCore || !hasFyreFunnel || !hasPublicForms) {
    return (
      <Card>
        <CardHeader>
          <CardTitle>Formulare derzeit nicht aktiv</CardTitle>
          <CardDescription>
            Öffentliche Formulare und FyreFunnel sind für diesen Mandanten aktuell nicht freigeschaltet.
          </CardDescription>
        </CardHeader>
        <CardContent className="text-sm text-muted-foreground">
          Aktivierung erfordert ein aktives CRM-Core-, FyreFunnel- und Public-Forms-Modul sowie ein Formularlimit größer als 0.
        </CardContent>
      </Card>
    );
  }

  if (formLimit < 1) {
    return (
      <Card>
        <CardHeader>
          <CardTitle>Keine neue Formularerstellung verfügbar</CardTitle>
          <CardDescription>
            Im aktuellen Tarif können keine neuen Formulare erstellt werden.
          </CardDescription>
        </CardHeader>
        <CardContent className="text-sm text-muted-foreground">
          Bestehende Formulare können weiterhin eingesehen und bearbeitet werden.
        </CardContent>
      </Card>
    );
  }

  if (formCount >= formLimit) {
    return (
      <Card>
        <CardHeader>
          <CardTitle>Formularlimit erreicht</CardTitle>
          <CardDescription>
            Ihr aktuelles Limit ist erreicht: {formCount} von {formLimit} Formularen.
          </CardDescription>
        </CardHeader>
        <CardContent className="text-sm text-muted-foreground">
          Sie können das bestehende Formular weiter bearbeiten.
        </CardContent>
      </Card>
    );
  }

  return null;
}
